import { yupResolver } from "@hookform/resolvers/yup";
import { Box, CircularProgress, Grid, Stack, Typography, useTheme } from "@mui/material";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import React, { useState } from "react";
import { getAuth, getIdTokenResult, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { firebaseApp, firebaseAuth } from "../firebase/app";
import Dialog from "../components/dialog/dialog";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { Button } from "../components";
import { EMAIL_REGEX } from "../utils/utils.service";
import ControlledInput from "../components/input/controlled-input";
import CustomSnackbar from "../components/snackbar/custom-snackbar";
import { useDispatch, useSelector } from "react-redux";
import { adminUidSet } from "../redux/authSlice";
import { roleSet } from "../redux/userSlice";
import { getMode } from "../redux/layoutSlice";
import { useResponsive } from "../hooks/use-media-query";
import EmailMessageIcon from "../assets/icon/email-message-setting";
import LockIcon from "../assets/icon/lock";

const schema = yup.object().shape({
  email: yup
    .string()
    .label("email")
    .required("Please enter your email")
    .email("Please enter a valid email")
    .matches(EMAIL_REGEX, "Please enter a valid email"),
  password: yup.string().label("password").required("password is required").min(3),
});

function ContactUs({ open, setOpen }: any) {
  const renderTitle = "Contact support";
  const renderContent = (
    <Typography align="center">
      Your account has been suspended, please contact support.
      <br /> (888) 288-8856.
    </Typography>
  );
  const renderActions = (
    <Box display={"flex"} justifyContent={"center"} width={"100%"}>
      <Button
        onClick={() => setOpen(false)}
        color="primary"
        sx={{
          color: "white",
          fontSize: 12,
          fontStyle: "normal",
          fontWeight: 400,
        }}
        variant="contained"
      >
        ok
      </Button>
    </Box>
  );

  return (
    <Dialog
      open={open}
      fullWidth
      handleClose={() => setOpen(false)}
      renderActions={renderActions}
      renderContent={renderContent}
      renderTitle={renderTitle}
    />
  );
}

const defaultValues = {
  email: "",
  password: "",
};

export default function Login() {
  const [loading, setLoading] = useState(false);

  const [state, setState] = useState({ message: "", open: false, type: "" });
  const [open, setOpen] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const dispatch = useDispatch();

  const mode = useSelector(getMode);
  const { isSmall } = useResponsive();

  const theme = useTheme();

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const handleRemoveAuth = () => {
    const auth = getAuth(firebaseApp);

    signOut(auth)
      .then(() => {
        setOpen(true);
        // Sign-out successful.
      })
      .catch((error) => console.log(error));
  };

  // check account access
  const getClaims = async () => {
    const auth = getAuth(firebaseApp);

    const user = auth?.currentUser;
    const idTokenResult = await user?.getIdTokenResult();

    const claims = idTokenResult?.claims;

    dispatch(roleSet(claims?.role));
    dispatch(adminUidSet(user?.uid));

    if (!user) return;
    getIdTokenResult(user, true)
      .then(async (r: any) => {
        // check exists salesAgent
        const product = r?.claims?.["salesAgent"];
        if (!product) handleRemoveAuth();
        if (product?.dashboard) {
          // Dashboard V2 access is handled after login by DashboardV2Modal,
          // which checks the flag on the dealership (manager) uid.
          //TODO: get branches
        } else handleRemoveAuth();
        setLoading(false);
      })
      .catch((e) => console.log(e));
  };

  const onSubmit = () => {
    const { email, password } = getValues();
    setLoading(true);
    signInWithEmailAndPassword(firebaseAuth, email, password)
      .then(() => {
        getClaims();
      })
      .catch((error) => {
        console.log("login error: ", error);
        setState({ message: "Incorrect email or password", open: true, type: "error" });
        setLoading(false);
      });
  };

  return (
    <>
      <Grid
        container
        component="main"
        sx={{
          // background: (theme) => theme.bg.paper,
          // backgroundColor: "#07A4FC",
          // backgroundImage: "linear-gradient(75deg, #000000a3, transparent)",
          backgroundImage: isSmall ? "none" : "url('/images/login-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "100vh",
          overflow: "hidden",
          [theme.breakpoints.down("lg")]: {
            justifyContent: "center",
          },
        }}
      >
        {!isSmall && (
          <Box
            sx={{
              position: "absolute",
              color: "white",
              fontSize: "38px",
              fontWeight: "700",
              left: "54%",
              top: "130px",
              textAlign: "center",
            }}
          >
            Your 24/7 AI Sales Teammate
            <br />
            For Modern Dealerships.
          </Box>
        )}
        <Grid item xs={12}>
          <Stack
            height={"100%"}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: isSmall ? "flex-start" : "center",
              alignItems: isSmall ? "center" : "flex-start",
              paddingLeft: isSmall ? "" : "10%",
              marginTop: isSmall ? "0" : "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                [theme.breakpoints.down("lg")]: {
                  marginBottom: 4.5,
                },
                position: "fixed",
                // left: "20px",
                top: "4dvh",
                // backgroundColor: "#ffffffde",
                padding: "8px 12px",
                borderRadius: "8px",
              }}
            >
              {/* <img
                width={isSmall ? "100px" : "460px"}
                alt="drivee logo"
                src="/images/DriveeLOGOLightVersion.webp"
                loading="lazy"
              /> */}
            </Box>

            <Box
              className="card example-5"
              style={{ position: "relative", width: isSmall ? "100%" : "" }}
            >
              <svg
                height="100%"
                width="100%"
                xmlns="http://www.w3.org/2000/svg"
                style={{ position: "absolute", display: isSmall ? "none" : "block" }}
              >
                <rect
                  rx="8"
                  ry="8"
                  className="line"
                  height="100%"
                  width="100%"
                  strokeLinejoin="round"
                  style={{
                    strokeDasharray: "500",
                    strokeWidth: "3px",
                    fill: "transparent",
                    stroke: "#39176f",
                    animation: "svgAnimation 5s linear infinite",
                  }}
                />
              </svg>
              <Box
                sx={{
                  position: "relative",
                  width: isSmall ? "100%" : "500px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  [theme.breakpoints.down("lg")]: {
                    marginBottom: 0,
                    // width: "90%",
                  },
                  [theme.breakpoints.down("sm")]: {
                    marginBottom: 0,
                    // width: "90%",
                  },
                  backgroundColor: isSmall ? "transparent" : mode === "dark" ? "#131517" : "white",
                  background: isSmall
                    ? "none"
                    : "radial-gradient(38.23% 35.22% at -2.06% 48.89%, rgba(36, 222, 247, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(27deg, rgba(0, 0, 0, 0.00) 65.67%, rgba(138, 56, 245, 0.20) 90.67%), linear-gradient(332deg, rgba(0, 0, 0, 0.00) 83.8%, rgba(138, 56, 245, 0.40) 96.38%), rgba(6, 9, 152, 0.12)",
                  padding: isSmall ? "24px" : "56px",
                  paddingTop: isSmall ? "24px" : "32px",
                  borderRadius: "8px",
                  // boxShadow: isSmall
                  //   ? "none"
                  //   : mode === "dark"
                  //     ? "5px 5px 34px #000000"
                  //     : "5px 5px 34px #d5d5d5",
                }}
              >
                <img
                  src="/images/DriveeLOGOLightVersion.webp"
                  alt="drivee logo"
                  style={{
                    width: isSmall ? "85px" : "64px",
                    height: "auto",
                    alignSelf: "center",
                    marginBottom: isSmall ? "48px" : "32px",
                  }}
                />

                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: "38px",
                    fontWeight: 400,
                    lineHeight: "36px",
                    marginBottom: "12px",
                    color: isSmall ? "" : "white",
                  }}
                >
                  Welcome Back
                </Typography>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "400",
                    lineHeight: "28px",
                    color: isSmall ? "" : "white",
                  }}
                >
                  Sign In To Your Account
                </Typography>

                <Box
                  sx={{
                    marginTop: "38px",
                    width: "100%",
                  }}
                >
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          height: "100px",
                        }}
                      >
                        <Controller
                          control={control}
                          name="email"
                          render={({ field }) => (
                            <ControlledInput
                              labelColor={isSmall ? "#858585" : "white"}
                              sx={{
                                backgroundColor: isSmall ? "transparent" : "#0D0F22",
                                color: isSmall ? "" : "white",
                                border: isSmall ? "1px solid #858585" : "1px solid #230023",
                                "& input": {
                                  caretColor: isSmall ? "" : "white",
                                },
                                "& input:-webkit-autofill": {
                                  WebkitTextFillColor: isSmall ? "" : "white !important",
                                  caretColor: isSmall ? "" : "white !important",
                                  WebkitBoxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                  boxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                },
                                "& input:-webkit-autofill:hover": {
                                  WebkitTextFillColor: isSmall ? "" : "white !important",
                                  caretColor: isSmall ? "" : "white !important",
                                  WebkitBoxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                  boxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                },
                                "& input:-webkit-autofill:focus": {
                                  WebkitTextFillColor: isSmall ? "" : "white !important",
                                  caretColor: isSmall ? "" : "white !important",
                                  WebkitBoxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                  boxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                },
                                "& input:-webkit-autofill:active": {
                                  WebkitTextFillColor: isSmall ? "" : "white !important",
                                  caretColor: isSmall ? "" : "white !important",
                                  WebkitBoxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                  boxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                },
                              }}
                              startAdornment={
                                <Box
                                  sx={{
                                    // borderRight: "2px solid #838383",
                                    // paddingRight: "8px",
                                    height: "20px",
                                    marginRight: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <EmailMessageIcon
                                    sx={{ stroke: "#838383", width: "16px", height: "16px" }}
                                  />
                                </Box>
                              }
                              error={errors.email && errors.email.message}
                              id="email"
                              label="Email"
                              placeholder="Enter Your Email"
                              type="email"
                              autoComplete="email"
                              {...field}
                            />
                          )}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          marginBottom: "16px",
                          height: "100px",
                        }}
                      >
                        <Controller
                          control={control}
                          name="password"
                          render={({ field }) => (
                            <ControlledInput
                              labelColor={isSmall ? "#858585" : "white"}
                              sx={{
                                backgroundColor: isSmall ? "transparent" : "#0D0F22",
                                color: isSmall ? "" : "white",
                                border: isSmall ? "1px solid #858585" : "1px solid #230023",
                                "& input": {
                                  caretColor: isSmall ? "" : "white",
                                },
                                "& input:-webkit-autofill": {
                                  WebkitTextFillColor: isSmall ? "" : "white !important",
                                  caretColor: isSmall ? "" : "white !important",
                                  WebkitBoxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                  boxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                },
                                "& input:-webkit-autofill:hover": {
                                  WebkitTextFillColor: isSmall ? "" : "white !important",
                                  caretColor: isSmall ? "" : "white !important",
                                  WebkitBoxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                  boxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                },
                                "& input:-webkit-autofill:focus": {
                                  WebkitTextFillColor: isSmall ? "" : "white !important",
                                  caretColor: isSmall ? "" : "white !important",
                                  WebkitBoxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                  boxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                },
                                "& input:-webkit-autofill:active": {
                                  WebkitTextFillColor: isSmall ? "" : "white !important",
                                  caretColor: isSmall ? "" : "white !important",
                                  WebkitBoxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                  boxShadow: isSmall
                                    ? "none"
                                    : "0 0 0 1000px #0D0F22 inset !important",
                                },
                              }}
                              startAdornment={
                                <Box
                                  sx={{
                                    // borderRight: "2px solid #838383",
                                    // paddingRight: "8px",
                                    height: "20px",
                                    marginRight: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <LockIcon
                                    sx={{ stroke: "#838383", width: "16px", height: "16px" }}
                                  />
                                </Box>
                              }
                              endAdornment={
                                <>
                                  {!showPass ? (
                                    <VisibilityRoundedIcon
                                      sx={{ cursor: "pointer", color: "#8083A3" }}
                                      onClick={() => setShowPass((prev) => !prev)}
                                    />
                                  ) : (
                                    <VisibilityOffRoundedIcon
                                      sx={{ cursor: "pointer", color: "#8083A3" }}
                                      onClick={() => setShowPass((prev) => !prev)}
                                    />
                                  )}
                                </>
                              }
                              label="Password"
                              error={errors.password && errors.password.message}
                              id="password"
                              placeholder="Enter Your Password"
                              type={showPass ? "text" : "password"}
                              autoComplete="current-password"
                              {...field}
                            />
                          )}
                        />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        marginBottom: "8px",
                        height: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{
                          height: "45px",
                          "&:hover": {
                            backgroundColor: "#2B7FFF",
                            boxShadow: "none",
                          },
                          background: "linear-gradient(101deg, #3B82F6 -1.78%, #9333EA 108.45%)",
                          // backgroundColor: "#022676",
                          // color: "white !important",
                          fontSize: "16px",
                          fontWeight: 700,
                          // borderRadius: "0.6rem",
                          textTransform: "initial",
                          py: "8px",
                          paddingX: "24px",
                          width: "100%",
                        }}
                        type="submit"
                        fullWidth
                      >
                        {loading ? <CircularProgress color="info" size={24} /> : "Sign In"}
                      </Button>
                    </Box>
                    <CustomSnackbar
                      handleClose={() => setState({ message: "", open: false, type: "error" })}
                      message={state.message}
                      open={state.open}
                      type={state.type}
                    />
                  </form>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Grid>

        {/* <Grid
          item
          xs={false}
          sm={4}
          md={6}
          sx={{
            // backgroundColor: "#07A4FC",
            backgroundColor: "transparent",
            [theme.breakpoints.down("lg")]: {
              display: "none",
            },
          }}
        >
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "inherit",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt="infinity logo"
                src="/images/infinitive.svg"
                style={{ width: "243px", height: "150px", opacity: "0.7", zIndex: 99 }}
                loading="lazy"
              />

              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: "700",
                  lineHeight: "36px",
                  textAlign: "center",
                  zIndex: 99,
                  position: "relative",
                  color: "white",
                  [theme.breakpoints.down("lg")]: {
                    fontSize: "20px",
                  },
                }}
              >
                Revolutionize your business <br /> with our cutting-edge AI solutions
              </Typography>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              <svg
                style={{ position: "absolute", bottom: "0" }}
                xmlns="http://www.w3.org/2000/svg"
                width="706"
                height="469"
                viewBox="0 0 706 469"
                fill="none"
              >
                <path
                  opacity="0.8"
                  d="M181.006 464.552L453.186 395.441C515.586 379.597 569.388 340.125 603.232 285.359L689.665 145.494C713.273 107.293 711.135 58.5443 684.274 22.5567C669.36 2.57656 642.823 -4.78964 619.745 4.64523L358.703 111.366C353.116 113.649 347.371 115.523 341.512 116.971L48.0167 189.495C16.0811 197.386 -4.14486 228.83 1.91682 261.163L20.8725 362.271C34.7306 436.189 108.114 483.06 181.006 464.552Z"
                  fill="#F5F0FC"
                />
              </svg>

              <img src="/images/signin.png" alt="sign-in" style={{ width: "90%", zIndex: 9 }} />
            </Box>
          </Box>
        </Grid> */}
      </Grid>

      <ContactUs open={open} setOpen={() => setOpen(false)} />
    </>
  );
}
